import { render, staticRenderFns } from "./settings-container.vue?vue&type=template&id=713905ee&scoped=true&lang=pug"
import script from "./settings-container.js?vue&type=script&lang=js&external"
export * from "./settings-container.js?vue&type=script&lang=js&external"
import style0 from "./settings-container.vue?vue&type=style&index=0&id=713905ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713905ee",
  null
  
)

export default component.exports